import { lazily } from 'react-lazily'
/**
 * Layouts
 */
import { SingleAction } from 'layout'
import Guard from 'guards/Guard'
/**
 * Alumnos
 */
const {
  Students,
  AlumnosEnviadosACaja,
  PendingStudents,
  EditStudent,
  UploadStudents,
  AllStudentsView,
  SpecialCasesView,
  ViewStudentDetail,
  UploadExcel,
  ParsedExcel,
  UploadExcelResult,
  HandleUploadDuplicates,
  AllDuplicatesHandled,
  UploadAssetsDefinition,
  UploadAssetsDefinitionExcel,
  ParsedAssetsDefinitionExcel,
  UploadAssetsDefinitionExcelResult,
  ViewProceedingDetails,
  ViewApprovedStudentDetail,
  SetSchoolcycleForAssetsDefinition,
  ViewProceedingEditDetails,
  BusStudentsView,
  UploadStudentsUniversity,
  UploadStudentUniversityExcel,
  ParsedStudentUniversityExcel,
  UploadStudentUniversityExcelResult
} = lazily(() => import('pages/students'))

const {
  Approval,
  Approvals,
  ViewPendingApproval,
  ViewValidationRejected,
  SpecialCaseForm,
  ViewSpecialCases,
} = lazily(() => import('pages/approvals'))

const { CreateProceeding, ViewAllProceedings, CreateBusProceeding } = lazily(() => import('pages/proceedings'))
/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/dashboard/educacion/'

const educacionRoutes = [
  {
    name: 'alumnos',
    path: basePath + 'alumnos',
    element: Students,
    suspenseFallback: null,
    childs: [
      {
        element: PendingStudents,
        homeForRole: ['Educacion'], //change this after creating oraculo home
        guard: Guard,
        guardProps: { allowedRoles: ['Educacion', 'Admin'] },
        name: 'alumnos-pendientes',
        path: 'pendientes-por-envio',
        index: true,
        childs: [
          {
            name: 'educacion-edit-pending-student',
            path: ':studentdni/editar',
            layoutProps: { title: 'Datos del alumno/a', fullscreen: false },
            layout: LAYOUTS.singleAction,
            element: EditStudent,
          },
          {
            name: 'educacion-view-pending-student',
            path: ':id/detalle',
            layoutProps: { title: "Datos del alumno/a" },
            element: ViewApprovedStudentDetail,
            layout: LAYOUTS.singleAction,
          },
          {
            name: 'create-acreditation-file',
            path: 'armar-expediente',
            layoutProps: { title: 'Armar lote' },
            element: CreateProceeding,
            layout: LAYOUTS.singleAction,
          },
        ],
      },
      {
        element: AllStudentsView,
        name: 'all-students',
        guard: Guard,
        guardProps: { allowedRoles: ['Educacion', 'Admin'] },
        path: 'todos-los-alumnos',
        childs: [
          {
            name: 'educacion-edit-student',
            path: ':studentdni/editar',
            layoutProps: { title: 'Datos del alumno/a', fullscreen: false },
            layout: LAYOUTS.singleAction,
            element: EditStudent,
          },
          {
            name: 'educacion-view-student',
            path: ':id/detalle',
            layoutProps: { title: "Datos del alumno/a" },
            element: ViewApprovedStudentDetail,
            layout: LAYOUTS.singleAction,
          },
          {
            name: 'create-acreditation-file-all-students',
            path: 'armar-expediente',
            layoutProps: { title: 'Armar lote' },
            element: CreateProceeding,
            layout: LAYOUTS.singleAction,
          },
        ],
      },
      {
        element: AlumnosEnviadosACaja,
        guard: Guard,
        guardProps: { allowedRoles: ['Educacion', 'Admin'] },
        name: 'alumnos-enviados',
        path: 'enviados',
        childs: [
          {
            name: 'detalle alumnos',
            path: ':studentdni',
            layoutProps: { title: 'Datos del alumno/a' },
            layout: LAYOUTS.singleAction,
            element: EditStudent,
          },
        ],
      },
      {
        element: ViewAllProceedings,
        name: 'ver-expedientes',
        path: 'expedientes',
        childs: [
          {
            name: 'detalle-expediente-pendiente',
            path: ':proceedingId',
            layoutProps: { title: 'Detalle del lote' },
            layout: LAYOUTS.singleAction,
            element: ViewProceedingDetails,
          },
          {
            name: 'detalle-expediente-editar',
            path: ':proceedingId/editar',
            layoutProps: { title: 'Editar el lote' },
            layout: LAYOUTS.singleAction,
            element: ViewProceedingEditDetails,
          },
        ],
      },
      {
        element: UploadStudents,
        layout: LAYOUTS.singleAction,
        layoutProps: { title: 'Cargar Alumnos/as' },
        name: 'cargar-alumnos',
        path: 'cargar-alumnos',
        childs: [
          {
            name: 'upload-excel',
            path: '',
            element: UploadExcel,
          },
          {
            name: 'parse-excel',
            path: 'resumen',
            element: ParsedExcel,
          },
          {
            name: 'excel-upload-results',
            path: 'resultado',
            element: UploadExcelResult,
          },
          {
            name: 'excel-upload-duplicates',
            path: 'ver-duplicados',
            element: HandleUploadDuplicates,
          },
          {
            name: 'duplicates-handled',
            path: 'duplicados-procesados',
            element: AllDuplicatesHandled,
          },
        ],
      },
      {
        name: 'upload-assets-definitions',
        path: 'cargar-definicion-de-activos',
        element: UploadAssetsDefinition,
        layout: LAYOUTS.singleAction,
        layoutProps: { title: 'Cargar definición de activos' },
        childs: [
          {
            name: 'set-schoocyrcle-for-assets-definition',
            index: true,
            path: 'seleccionar-ciclo',
            element: SetSchoolcycleForAssetsDefinition,
          },
          {
            name: 'upload-assets-definitions-excel',
            path: 'seleccionar-archivo',
            element: UploadAssetsDefinitionExcel,
          },
          {
            name: 'parsed-assets-definitions-excel',
            path: 'resumen',
            element: ParsedAssetsDefinitionExcel,
          },
          {
            name: 'assets-definitions-upload-results',
            path: 'resultado',
            element: UploadAssetsDefinitionExcelResult,
          },
        ],
      },
      {
        element: SpecialCasesView,
        name: 'casos-especiales',
        path: 'casos-especiales',
        guard: Guard,
        guardProps: { allowedRoles: ['Educacion', 'Admin'] },
        childs: [
          {
            name: 'special-cases-edit-pending-student',
            path: ':studentdni/editar',
            layoutProps: { title: 'Datos del alumno/a', fullscreen: false },
            layout: LAYOUTS.singleAction,
            element: EditStudent,
          },
          {
            name: 'special-cases-view-pending-student',
            path: ':id/detalle',
            layoutProps: { title: 'Datos del alumno/a' },
            element: ViewStudentDetail,
            layout: LAYOUTS.singleAction,
          },
          {
            name: 'create-acreditation-file-special-cases',
            path: 'armar-expediente',
            layoutProps: { title: 'Armar lote' },
            element: CreateProceeding,
            layout: LAYOUTS.singleAction,
          },
        ],
      },
      {
        element: BusStudentsView,
        name: 'bus',
        path: 'bus',
        guard: Guard,
        guardProps: { allowedRoles: ['Educacion', 'Admin'] },
        childs: [
          {
            name: 'educacion-edit-pending-student',
            path: ':studentdni/editar',
            layoutProps: { title: 'Datos del alumno/a', fullscreen: false },
            layout: LAYOUTS.singleAction,
            element: EditStudent,
          },
          {
            name: 'educacion-view-pending-student',
            path: ':id/detalle',
            layoutProps: { title: "Datos del alumno/a" },
            element: ViewApprovedStudentDetail,
            layout: LAYOUTS.singleAction,
          },
          {
            name: 'create-acreditation-file-bus',
            path: 'armar-expediente',
            layoutProps: { title: 'Armar lote BUS', isBus: true },
            element: CreateBusProceeding,
            layout: LAYOUTS.singleAction,
          },
          {
            element: UploadStudentsUniversity,
            layout: LAYOUTS.singleAction,
            layoutProps: { title: 'Importar Universidades' },
            name: 'importar-estudiantes-universidad',
            path: 'importar-estudiantes-universidad',
            childs: [
              {
                name: 'upload-excel',
                path: '',
                element: UploadStudentUniversityExcel,
              },
              {
                name: 'parse-excel',
                path: 'resumen',
                element: ParsedStudentUniversityExcel,
              },
              {
                name: 'excel-upload-results',
                path: 'resultado',
                element: UploadStudentUniversityExcelResult,
              }
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'aprobaciones',
    path: basePath + 'aprobaciones',
    element: Approvals,
    suspenseFallback: null,
    childs: [
      {
        name: 'ver-aprobaciones-alumnos-pendientes',
        path: 'pendientes',
        element: ViewPendingApproval,
        index: true,
        childs: [
          {
            name: 'validar-alumno',
            path: ':studentdni',
            layoutProps: { title: "Aprobaciones" },
            element: Approval,
            layout: LAYOUTS.singleAction,
          },
        ],
      },
      {
        name: 'ver-aprobaciones-alumnos-rechazados',
        path: 'rechazados',
        element: ViewValidationRejected,
        childs: [
          {
            name: 'revalidar-alumno',
            path: ':studentdni',
            layoutProps: { title: "Aprobaciones" },
            element: Approval,
            layout: LAYOUTS.singleAction,
          },
        ],
      },
      {
        name: 'ver-aprobaciones-casos-especiales',
        path: 'casos-especiales',
        guard: Guard,
        guardProps: { allowedRoles: ['Educacion', 'Admin'] },
        element: ViewSpecialCases,
        childs: [
          {
            name: 'alumno-caso-especial',
            path: ':studentdni',
            layoutProps: { title: "Aprobaciones" },
            element: SpecialCaseForm,
            layout: LAYOUTS.singleAction,
          },
        ],
      },
    ]

  }
]
export default educacionRoutes